import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import SEO from "../components/SEO";
import { makeStyles } from "@material-ui/core";
import { motion, transform } from "framer-motion";
import Link from "../components/v2/Link";
import LazyImage from "../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../components/v4/FaqSection/FaqSection";
import TestimonialSlider from "../components/v3/TestimonialSlider/TestimonialSlider";
import TruestedSection from "../components/v4/TrustedSection/TruestedSection";

import aiCRMHeroImg from "../images/v4/aiFeatures/listingPage/images/aiCRMHeroImg.webp";
import aiCRMHeroBg from "../images/v4/aiFeatures/listingPage/images/aiCRMHeroBg.png";
import aiFeaturesBg from "../images/v4/aiFeatures/listingPage/images/aiFeaturesBg.png";
import moreSideRightButton from "../images/v4/aiFeatures/listingPage/icons/learnmoreright.png";
import industryAdaptBg from "../images/v4/aiFeatures/listingPage/images/industryAdaptBg.png";
import bussinessSuccessbg from "../images/v4/aiFeatures/listingPage/images/bussinessSuccessbg.png";
import assistAiIntegration from "../images/v4/aiFeatures/listingPage/images/assistAiIntegration.webp";
import assistAiBg from "../images/v4/aiFeatures/listingPage/images/assistAiBg.png";

import contentIcon1 from "../images/v4/aiFeatures/listingPage/icons/contentIcon1.svg";
import contentIcon2 from "../images/v4/aiFeatures/listingPage/icons/contentIcon2.svg";
import contentIcon3 from "../images/v4/aiFeatures/listingPage/icons/contentIcon3.svg";
import contentIcon4 from "../images/v4/aiFeatures/listingPage/icons/contentIcon4.svg";
import contentIcon5 from "../images/v4/aiFeatures/listingPage/icons/contentIcon5.svg";
import contentIcon6 from "../images/v4/aiFeatures/listingPage/icons/contentIcon6.svg";
import contentIcon7 from "../images/v4/aiFeatures/listingPage/icons/contentIcon7.svg";

import adaptImg1 from "../images/v4/aiFeatures/listingPage/icons/adaptImg1.svg";
import adaptImg2 from "../images/v4/aiFeatures/listingPage/icons/adaptImg2.svg";
import adaptImg3 from "../images/v4/aiFeatures/listingPage/icons/adaptImg3.svg";
import adaptImg4 from "../images/v4/aiFeatures/listingPage/icons/adaptImg4.svg";
import adaptImg5 from "../images/v4/aiFeatures/listingPage/icons/adaptImg5.svg";

import partnerIcon1 from "../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../images/v4/aiPage/icons/partnerIcon8.png";

import featureIcon1 from "../images/v4/aiFeatures/listingPage/icons/featureIcon1.svg";
import featureIcon2 from "../images/v4/aiFeatures/listingPage/icons/featureIcon2.svg";
import featureIcon3 from "../images/v4/aiFeatures/listingPage/icons/featureIcon3.svg";
import featureIcon4 from "../images/v4/aiFeatures/listingPage/icons/featureIcon4.svg";
import featureIcon5 from "../images/v4/aiFeatures/listingPage/icons/featureIcon5.svg";
import featureIcon6 from "../images/v4/aiFeatures/listingPage/icons/featureIcon6.svg";
import featureIcon7 from "../images/v4/aiFeatures/listingPage/icons/featureIcon7.svg";
import featureIcon8 from "../images/v4/aiFeatures/listingPage/icons/featureIcon8.svg";
import featureIcon9 from "../images/v4/aiFeatures/listingPage/icons/featureIcon9.svg";
import featureIcon10 from "../images/v4/aiFeatures/listingPage/icons/featureIcon10.svg";
import featureIcon11 from "../images/v4/aiFeatures/listingPage/icons/featureIcon11.svg";
import featureIcon12 from "../images/v4/aiFeatures/listingPage/icons/featureIcon12.svg";
import featureIcon13 from "../images/v4/aiFeatures/listingPage/icons/featureIcon13.svg";
import featureIcon14 from "../images/v4/aiFeatures/listingPage/icons/featureIcon14.svg";
import featureIcon15 from "../images/v4/aiFeatures/listingPage/icons/featureIcon15.svg";

const useStyles = makeStyles((theme) => ({
  IndustrySection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${aiCRMHeroBg})`,
    backgroundPosition: "bottom",
    padding: "60px 0 40px",
    "& .highlight": {
      background: "linear-gradient(90deg, #0853FC 0%, #03C3B5 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& $aiSectionLeft": {
      width: "50%",
      gap: "25px",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 600px)": {
      "& $aiSectionLeft": {
        width: "100%",
      },
      paddingTop: "0px",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
      },
      "& .container": {
        paddingBottom: "20px",
      },
    },
  },
  aiSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "60px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  aiSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "20px",
    "& .highlighterText": {
      background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  aiSectionRight: {
    width: "40%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },

  performanceSection: {
    padding: "40px 0",
    backgroundImage: `url(${aiFeaturesBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "& $integrationLeft": {
      width: "50%",
      gap: "20px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "fle-start",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "40px 0",
      "& $integrationLeft": {
        width: "100%",
      },
    },
  },

  integrationindustryHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    maxWidth: "800px",
    margin: "0 auto 48px",
    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
    },
  },

  statsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3,1fr)",
    alignItems: "stretch",
    gap: "24px",
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "40px",
    "@media only screen and (max-width: 700px)": {
      gap: "15px",
      marginTop: "20px",
      position: "relative",
       gridTemplateColumns: "repeat(2,1fr)",
    },
    "@media only screen and (max-width: 450px)": {
       gridTemplateColumns: "repeat(1,1fr)",
    },
  },
  customerExperencesBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "50px",
    background:
      "linear-gradient(129deg, rgba(255, 255, 255, 0.10) 0%, rgba(0, 137, 255, 0.10) 100%)",
    borderRadius: "16px",
    padding: "20px",
    minHeight: "230px",
    backdropFilter: "blur(30px) brightness(0.8)",
    overflow: "hidden",
    transition: ".2s ease-in-out",
    "&:hover": {
      background:
        "linear-gradient(129deg, rgba(255, 255, 255, 0.30) 0%, rgba(0, 137, 255, 0.30) 100%)",
    },
    "& p:nth-child(2)": {
      color: "#fff",
    },
    "& p:last-child": {
      color: "#fff",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      padding: "15px",
      borderRadius: "20px",
      minHeight: "max-content",
    },
    "&.orangeCard1": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard3": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard7": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard5": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard3": {
      background: "rgba(0, 154, 153, 0.4)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #1ADAD9 50%, #00aa7c 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard0": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard2": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard4": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard6": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.greenCard7": {
      background: "#002C51",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #208EEC 50%, #002C51 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
  },
  customerExperencesBoxBody: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: "1",
    alignItems: "stretch",
    gap: "24px",

    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
    "& .description": {
      flex: "1",
    },
  },
  learnMorelink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  moreSideButton: {
    width: "42px",
    minWidth: "42px",
    minHeight: "42px",
    height: "42px",
    position: "relative",
    borderRadius: "50%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      opacity: "0.2",
      backgroundColor: "#fff",
    },
    "& img": {
      width: "24px",
      height: "24px",
      transform: "rotate(-90deg)",
    },
  },
  adaptFeatures: {
    paddingTop: "0",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${industryAdaptBg})`,
    "& .header": {
      display: "flex",
      width: "100%",
      gap: "50px",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      textAlign: "left",
      "& h2": {
        width: "50%",
      },
      "& p": {
        width: "50%",
      },
      "@media(max-width: 768px)": {
        gap: "24px",
        flexDirection: "column",
        justifyContent: "flex-start",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
    "& .body": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      "& .body": {
        flexDirection: "column",
        flexWrap: "wrap",
        rowGap: "15px",
      },
    },
    "@media only screen and (min-width: 1900px)": {
      "& .container": {
        paddingTop: "65px",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "streach",
      padding: "16px 8px",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    // minHeight: "220px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptDescription: {
    gap: "10px",
    minHeight: "80px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
    },
  },
  adaptBoxImg: {
    width: "48px",
    maxWidth: "48px",
    position: "relative",
    bottom: "0",
    marginBottom: "24px",
  },
  aiPoweredContainer: {
    backgroundColor: "rgba(224, 239, 253, 1)",
  },
  aiPoweredClientContainer: {
    textAlign: "center",
  },

  partnerSlide: {
    width: "144px !important",
    filter: "brightness(0.1)",
    "& img": {
      width: "144px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "max-content !important",
      "& img": {
        width: "100px",
      },
      // marginRight: "20px !important",
    },
  },
  partnerSlider: {
    padding: "10px 0  65px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  testimonialSlide: {
    backgroundColor: "rgba(224, 239, 253, 1)",
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  combineSection: {
    position: "relative",
  },
  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    paddingBottom: "200px",
    paddingTop: "100px",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        borderRadius: "50px",
        color: "#010F1D",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "80px 0 120px",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "28%",
    "@media only screen and (max-width: 600px)": {
      top: "28%",
    },
  },
  integrationSection: {
    backgroundImage: `url(${assistAiBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "250px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "160px",
    },
    "& .primaryButtonOutline": {
      minWidth: "auto",
    },
  },
  detailCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column-reverse",
      gap: "40px",
    },
  },
  detailCardLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "38%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "&.card2": {
        width: "100%",
      },
    },
  },
  detailCardRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "48%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
}));

const BestAiCRMFeatures = () => {
  const classes = useStyles();

  const allIcons = [
    {
      img: featureIcon1,
      title: "Auto-lead capture",
      bgColor: "#CEE9FF",
    },
    {
      img: featureIcon2,
      title: "Sales pipeline management",
      bgColor: "#FFE9DA",
    },
    {
      img: featureIcon3,
      title: "WhatsApp CRM",
      bgColor: "#BEE7E7",
    },
    {
      img: featureIcon4,
      title: "Omnichannel CRM",
      bgColor: "#F1DFFF",
    },
    {
      img: featureIcon5,
      title: "Workflow automation",
      bgColor: "#FFEDD2",
    },
    {
      img: featureIcon6,
      title: "Contact management",
      bgColor: "#CEE9FF",
    },
    {
      img: featureIcon7,
      title: "Email marketing",
      bgColor: "#CEE9FF",
    },
    {
      img: featureIcon8,
      title: "Sales forecasting",
      bgColor: "#FFE9DA",
    },
    {
      img: featureIcon9,
      title: "Mobile CRM",
      bgColor: "#BEE7E7",
    },
    {
      img: featureIcon10,
      title: "Quotation generation",
      bgColor: "#BEE7E7",
    },
    {
      img: featureIcon11,
      title: "AI chatbot",
      bgColor: "#CEE9FF",
    },
    {
      img: featureIcon12,
      title: "UTM tracking",
      bgColor: "#FFE9DA",
    },
    {
      img: featureIcon13,
      title: "VOIP tool integration",
      bgColor: "#F1DFFF",
    },
    {
      img: featureIcon14,
      title: "Real-time dashboard",
      bgColor: "#FFEDD2",
    },
    {
      img: featureIcon15,
      title: "Video conferencing",
      bgColor: "#F1DFFF",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title),
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }
  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);
  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  const aiFeaturesBoxContent = [
    {
      icon: contentIcon1,
      link: "/best-ai-crm-features/ai-assistant-panel-for-crm/",
      heading: "AI assistant panel",
      data: "Perform CRM actions using plain language. Create leads, tasks, and notes instantly. Let AI automate your follow-ups and deliver smart suggestions — all from a single panel.",
    },
    {
      icon: contentIcon2,
      link: "/best-ai-crm-features/ai-knowledge-base-for-crm/",
      heading: "AI knowledge base",
      data: "Turn your documents, cloud links, and chat history into real-time answers. Help your team respond faster with an AI knowledge base that continuously learns and improves.",
    },
    {
      icon: contentIcon3,
      link: "/best-ai-crm-features/ai-chatbot-for-crm/",
      heading: "AI chatbot",
      data: "Engage visitors across channels with intelligent conversations. Capture leads, answer questions, and seamlessly switch to human agents when needed.",
    },
    {
      icon: contentIcon4,
      link: "/best-ai-crm-features/ai-powered-sales-insights/",
      heading: "AI insights",
      data: "Auto-summarise chats, extract questions, and generate action points with ease. AI insights keep your team one step ahead during every customer interaction.",
    },
    {
      icon: contentIcon5,
      link: "/best-ai-crm-features/smart-crm-messaging-with-ai",
      heading: "Smart messaging with AI",
      data: "Create tasks, reply faster, and gain instant clarity — all within your CRM chat window. Turn conversations into conversions with smart messaging features.",
    },
    {
      icon: contentIcon6,
      link: "/best-ai-crm-features/ai-driven-sentiment-analysis",
      heading: "AI sentiment analysis",
      data: "Understand the emotional tone behind every closed conversation. Spot trends, prioritise follow-ups, and coach your team based on real-time customer sentiment.",
    },
    {
      icon: contentIcon7,
      link: "/best-ai-crm-features/ai-text-modification-with-crm",
      heading: "AI communication tools",
      data: "Rephrase, summarise, or fine-tune your messages in seconds. Save time and send polished, on-brand replies that build trust and convert leads.",
    },
  ];

  const adaptList = [
    {
      pointer: "Flexible setup",
      desc: "Easily aligns with solo users, startups, and growing teams without heavy configuration.",
      img: adaptImg1,
      alt: "Flexible setup",
    },
    {
      pointer: "Custom workflows",
      desc: "Map CRM features to your real-world processes — no need to change the way you work.",
      img: adaptImg2,
      alt: "Custom workflows",
    },
    {
      pointer: "Role-based access",
      desc: "Give sales reps, managers, and support teams the exact views and tools they need.",
      img: adaptImg3,
      alt: "Role based access",
    },
    {
      pointer: "Unified collaboration",
      desc: "Bring together updates from WhatsApp, email, and CRM chat for full team visibility.",
      img: adaptImg4,
      alt: "Unified collaboration",
    },
    {
      pointer: "Smart automation",
      desc: "Automate tasks, follow-ups, and insights so your team can focus on closing deals.",
      img: adaptImg5,
      alt: "Smart automation",
    },
  ];
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];

  const faqs = [
    {
      question: "What is AI CRM?",
      answer: (
        <>
          AI CRM stands for Artificial Intelligence-powered Customer
          Relationship Management. It combines traditional CRM tools with
          intelligent features like chatbots, automated insights, and predictive
          analytics to improve how businesses manage and grow customer
          relationships.
        </>
      ),
    },
    {
      question: "How to use AI in CRM?",
      answer: (
        <>
          You can use AI in CRM to automate routine tasks, predict sales
          outcomes, personalise communication, and gain real-time insights.
          Tools like AI chatbots, smart assistants, and auto-summary features
          help teams save time and focus on selling.
        </>
      ),
    },
    {
      question: "What is the role of AI in modern CRM systems?",
      answer: (
        <>
          AI plays a vital role in modern CRM systems by making them proactive
          rather than reactive. It enables faster decision-making, smarter
          workflows, and better customer experiences — all through automation,
          data analysis, and predictive intelligence.
        </>
      ),
    },
    {
      question: "What are some CRM AI use cases?",
      answer: (
        <>
          Common CRM AI use cases include lead scoring, chatbot support,
          conversation summaries, email response suggestions, task automation,
          sentiment analysis, and content rephrasing — all helping sales teams
          move faster and more effectively.
        </>
      ),
    },
    {
      question: "What is an AI-based CRM?",
      answer: (
        <>
          An AI-based CRM is a customer relationship platform that integrates
          artificial intelligence to enhance performance. Paper Cloud, for
          example, uses AI to streamline communication, automate follow-ups,
          deliver insights, and personalise every interaction.
        </>
      ),
    },
    {
      question: "Why choose an AI-based CRM over a traditional CRM?",
      answer: (
        <>
          An AI-based CRM goes beyond data storage — it actively supports your
          sales process. With smart suggestions, automation, and predictive
          insights, it helps your team reduce manual work and engage with leads
          more effectively than traditional systems.
        </>
      ),
    },
    {
      question: "Can small businesses benefit from AI CRM use cases?",
      answer: (
        <>
          Absolutely. AI CRM features like lead capture, chat automation, and
          message rephrasing are especially useful for small teams with limited
          time and resources. Paper Cloud makes powerful CRM AI use cases
          accessible to every business.
        </>
      ),
    },
  ];

  const benifitList = [
    {
      tag: "AssistAI",
      img: assistAiIntegration,
      title: "Smart AI CRM features built for modern sales",
      desc: "Paper Cloud brings together the smartest AI features your sales team needs — all in one CRM. From AI assistant panels and real-time knowledge bases to chatbots, sentiment analysis, and automated insights, every feature is designed to reduce manual work, speed up conversations, and help your team close deals faster.",
    },
  ];

  return (
    <main>
      <SEO
        description={
          "Discover the best AI CRM features from Paper Cloud — including AI chatbots, insights, sentiment analysis, and automation. Learn what is AI CRM, its use cases, and the role of AI in modern CRM systems."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is AI CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "AI CRM stands for Artificial Intelligence-powered Customer Relationship Management. It combines traditional CRM tools with intelligent features like chatbots, automated insights, and predictive analytics to improve how businesses manage and grow customer relationships.",
                },
              },
              {
                "@type": "Question",
                name: "How to use AI in CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can use AI in CRM to automate routine tasks, predict sales outcomes, personalise communication, and gain real-time insights. Tools like AI chatbots, smart assistants, and auto-summary features help teams save time and focus on selling.",
                },
              },
              {
                "@type": "Question",
                name: "What is the role of AI in modern CRM systems?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "AI plays a vital role in modern CRM systems by making them proactive rather than reactive. It enables faster decision-making, smarter workflows, and better customer experiences — all through automation, data analysis, and predictive intelligence.",
                },
              },
              {
                "@type": "Question",
                name: "What are some CRM AI use cases?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Common CRM AI use cases include lead scoring, chatbot support, conversation summaries, email response suggestions, task automation, sentiment analysis, and content rephrasing — all helping sales teams move faster and more effectively.",
                },
              },
              {
                "@type": "Question",
                name: "What is an AI-based CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "An AI-based CRM is a customer relationship platform that integrates artificial intelligence to enhance performance. Paper Cloud, for example, uses AI to streamline communication, automate follow-ups, deliver insights, and personalise every interaction.",
                },
              },
              {
                "@type": "Question",
                name: "Why choose an AI-based CRM over a traditional CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "An AI-based CRM goes beyond data storage — it actively supports your sales process. With smart suggestions, automation, and predictive insights, it helps your team reduce manual work and engage with leads more effectively than traditional systems.",
                },
              },
              {
                "@type": "Question",
                name: "Can small businesses benefit from AI CRM use cases?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. AI CRM features like lead capture, chat automation, and message rephrasing are especially useful for small teams with limited time and resources. Paper Cloud makes powerful CRM AI use cases accessible to every business.",
                },
              },
            ],
          },
        ]}
        keywords="Pepper Cloud AI CRM dashboard, AI CRM for sales automation, AI assistant panel in CRM, AI CRM chatbot and insights, AI-powered CRM for growing teams"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/best-ai-crm-features/"}
        title={"Best AI CRM features for smarter sales | Pepper Cloud"}
      />
      <section className={classes.IndustrySection}>
        <div className="container">
          <div className={classes.aiSectionContainer}>
            <div className={classes.aiSectionLeft}>
              <motion.h1
                className="font-wix-semibold font-64 font-white"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Transform your sales with smart{" "}
                <span className="highlight">AI CRM</span>
              </motion.h1>
              <motion.p
                className="font-wix-regular font-18  font-white"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Boost speed, automate tasks, and close deals faster with Pepper
                Cloud’s AI CRM. From smart chatbots to real-time insights, sell
                smarter and grow effortlessly.
              </motion.p>
              <div className="buttonContaienr">
                {/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
                <Link
                  className=" primaryButton font-inter-medium font-16 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a demo
                </Link>
              </div>
            </div>
            <motion.div
              className={classes.aiSectionRight}
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <LazyImage alt={"AI CRM"} source={aiCRMHeroImg} width={"100%"} />
            </motion.div>
          </div>
        </div>
      </section>

      <section className={classes.performanceSection}>
        <div className="container">
          <div className={classes.integrationindustryHeader}>
            <div className={classes.integrationContent}>
              <motion.h2
                className="font-wix-semibold font-56 color-black7"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Every business needs a feature-rich AI CRM
              </motion.h2>
              <motion.p
                className="font-wix-regular font-18 colorWhite"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Over 80% of growing businesses rely on AI-driven CRMs to save
                time and boost sales.Pepper Cloud offers powerful, scalable
                features that support every stage of your customer journey.
              </motion.p>
            </div>
          </div>
          <div className={classes.statsContainer}>
            {aiFeaturesBoxContent.map((stat, index) => (
              <motion.div
                className={clsx(classes.customerExperencesBox)}
                key={index}
                transition={{ duration: 1, delay: index * 0.1 }}
                whileInView={{ opacity: [0, 1], y: [50, 0] }}
              >
                {/* <div className={classes.statsBoxHeader}>
                        <p className="font-18 color-purple3 font-wix-regular">
                          {stat.heading}
                        </p>
                      </div> */}
                <div className={classes.customerExperencesBoxBody}>
                  <div className={classes.statsFontImg}>
                    <img alt={stat.alt} src={stat.icon} />
                  </div>

                  <p className="font-24 font-wix-semibold heading">
                    {stat.heading}
                  </p>
                  <p className="font-16 font-wix-regular font-white description">
                    {stat.data}
                  </p>
                  <Link className={classes.learnMorelink} to={stat.link}>
                    <span className="font-18 font-white font-wix-medium">
                      Learn more
                    </span>{" "}
                    <span className={classes.moreSideButton}>
                      <img alt="Learn more" src={moreSideRightButton} />
                    </span>
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Best AI CRM that fits your team structure
            </motion.h2>
            <motion.p
              className="font-wix-regular font-18 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              No matter your business size or workflow, Paper Cloud adapts. If
              you're wondering what is AI CRM or looking to understand the role
              of AI CRM systems, our features are designed to work around your
              team not the other way around.
            </motion.p>
          </div>
        </div>
        <Swiper
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          grabCursor={true}
          loop={true}
          modules={[Autoplay]}
          speed={5000}
          slidesPerView={"auto"}
          // centeredSlides={true}
          spaceBetween={30}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  // alt={point.card.alt}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className={classes.combineSection}>
        <section className={classes.bussinessSuccesSection}>
          <div className={classes.integrationHeaderItem}>
            <div className={classes.integrationContent}>
              <motion.h2
                className="font-wix-semibold font-56 color-black"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Pepper Cloud CRM AI features for business success
              </motion.h2>
            </div>
          </div>

          <section>
            <div className="logos-container">
              <div className="scroll-container">
                <div
                  className="logos-row"
                  data-direction="left"
                  data-speed="0.8"
                >
                  <div className="logos-track">
                    {logotrack1.map((logo) => (
                      <div
                        className="logo font-18 font-wix-medium color-black1"
                        style={{ backgroundColor: logo.bgColor }}
                      >
                        <img alt={`${logo.title} integration`} src={logo.img} />
                        <p>{logo.title}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div
                  className="logos-row"
                  data-direction="right"
                  data-speed="0.8"
                >
                  <div className="logos-track">
                    {logotrack2.map((logo) => (
                      <div
                        className="logo font-18 font-wix-medium color-black1"
                        style={{ backgroundColor: logo.bgColor }}
                      >
                        <img alt={`${logo.title} integration`} src={logo.img} />
                        <p>{logo.title}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>

        {benifitList.map((benifit, index) => (
          <section className={classes.integrationSection}>
            <div className="container">
              <div className={classes.detailCard}>
                          <div className={classes.detailCardRight}>
                            <motion.p
                              initial={{ opacity: 1, y: 20 }}
                              whileInView={{ opacity: 1, y: 0 }}
                              transition={{ duration: 0.3 }}
                              className="font-wix-semibold font-20 font-white"
                            >
                              {benifit.tag}
                            </motion.p>
                            <motion.h2
                              initial={{ opacity: 1, y: 20 }}
                              whileInView={{ opacity: 1, y: 0 }}
                              transition={{ duration: 0.3 }}
                              className="font-wix-semibold font-56 font-white"
                            >
                               {benifit.title}
                            </motion.h2>
                            <motion.p
                              initial={{ opacity: 0, x: -20 }}
                              whileInView={{ opacity: 1, x: 0 }}
                              transition={{ duration: 0.3 }}
                              className="font-wix-regular font-18 font-white"
                            >
                               {benifit.desc}
                            </motion.p>
                          </div>
                          <div className={classes.detailCardLeft}>
                            <LazyImage
                              width={"100%"}
                              source={assistAiIntegration}
                              alt={benifit.tag}
                            />
                          </div>
                        </div>
            </div>
          </section>
        ))}
      </section>

      <section className={classes.aiPoweredContainer}>
        <div className="container">
          <div className={classes.aiPoweredClientContainer}>
            <motion.h2
              className="font-wix-medium font-24 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Trusted by leading businesses for outstanding efficiency
            </motion.h2>
          </div>
        </div>
        <Swiper
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          className={classes.partnerSlider}
          loop={true}
          modules={[Autoplay]}
          slidesPerView="auto"
          spaceBetween={60}
          speed={2000}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img alt={partner.alt} src={partner.icon} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className={classes.testimonialSlide}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Trusted by businesses worldwide"}
          noButton={true}
        />
      </section>

      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          faqs={faqs}
          heading={"Frequently asked questions about AI CRM features"}
        />
      </div>

      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Ready to experience the best AI CRM features for your business?
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BestAiCRMFeatures;
